import { render } from "./CalendarControls.vue?vue&type=template&id=4130b736&scoped=true"
import script from "./CalendarControls.vue?vue&type=script&lang=js"
export * from "./CalendarControls.vue?vue&type=script&lang=js"

import "./CalendarControls.vue?vue&type=style&index=0&id=4130b736&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4130b736"]])

export default __exports__